import type { FC } from 'react'
import { useEffect, useState } from 'react'

import { Input, Toggle } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { Container } from '@skytech/ui/Container'
import { useDebounce } from '@skytech/utils'
import PlusIcon from 'mdi-react/PlusIcon'
import { useNavigate } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import { useTranslation } from '@/app/translations/translations-hooks'
import { useAdminAccess } from '@/hooks/access'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import { APP_ROUTES } from '@/util/app-routes'

import PolicyList from './PolicyList'

import './PolicyList.styles.scss'

const Policies: FC = () => {
  useAdminAccess()

  const translate = useTranslation()
  const navigate = useNavigate()

  const [querySearch, setQuerySearch] = useSearchParamsByKey('search')
  const [searchFilter, setSearchFilter] = useState(querySearch || '')
  const [queryShowInactive, setQueryShowInactive] = useSearchParamsByKey('show_inactive')

  const debouncedSearchTerm = useDebounce(searchFilter, 500)

  useEffect(() => {
    setSearchFilter(querySearch || '')
  }, [querySearch])

  useEffect(() => {
    setQuerySearch(debouncedSearchTerm)
    setQueryShowInactive(queryShowInactive || '')
  }, [debouncedSearchTerm, queryShowInactive, setQuerySearch, setQueryShowInactive])

  return (
    <Container className="ecom-policy-list">
      <Container.Header>
        <Translation id="Shop Policies" />
      </Container.Header>

      <Button
        className="mb-4 ml-0"
        Icon={<PlusIcon />}
        onClick={() => navigate(APP_ROUTES.HARDWARE_ECOM_POLICY_NEW)}
      >
        <Translation id="New policy" />
      </Button>

      <div className="filter">
        <div className="filter__text-filter">
          <Input
            id="searchFilter"
            type="text"
            value={searchFilter}
            placeholder={translate('Search')}
            onChange={e => setSearchFilter(e.target.value)}
          />
        </div>

        <div className="w-40">
          <Toggle
            id="show-inactive"
            checked={queryShowInactive === 'true'}
            label={<Translation id="Show inactive" />}
            onChange={() => setQueryShowInactive(queryShowInactive === 'true' ? 'false' : 'true')}
          />
        </div>
      </div>

      <PolicyList searchFilter={searchFilter} />
    </Container>
  )
}

export default Policies
